import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ServiceOrderRefreshService {
  private refreshTableSource = new Subject<void>();
  refreshTable$ = this.refreshTableSource.asObservable();

  triggerRefresh() {
    this.refreshTableSource.next();
  }
}
